module.exports = __webpack_public_path__ + "static/media/bg16.150b1c9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg16.jpg
// module id = 3964
// module chunks = 0